import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=f11113b6&scoped=true&"
import script from "./drag.vue?vue&type=script&lang=js&"
export * from "./drag.vue?vue&type=script&lang=js&"
import style0 from "./drag.vue?vue&type=style&index=0&id=f11113b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11113b6",
  null
  
)

export default component.exports